import React, { useState, useEffect, useRef } from 'react';
import './NavbarStyling.css';

const Navbar = ({ onMenuToggle, isMenuOpen }) => {
  const [scrolled, setScrolled] = useState(false);
  // 4-phase state: '' (closed) | 'opening' | 'open' | 'closing'
  const [burgerAnim, setBurgerAnim] = useState('');
  const isFirstRender = useRef(true);
  const magnetZoneRef = useRef(null);
  const magnetBtnRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    handleScroll(); // sync state immediately on mount
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Drive the hamburger through its animation phases
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (isMenuOpen) {
      setBurgerAnim('opening');
      const t = setTimeout(() => setBurgerAnim('open'), 520);
      return () => clearTimeout(t);
    } else {
      setBurgerAnim('closing');
      const t = setTimeout(() => setBurgerAnim(''), 520);
      return () => clearTimeout(t);
    }
  }, [isMenuOpen]);

  const handleMagnet = (e) => {
    const zone = magnetZoneRef.current;
    const btn = magnetBtnRef.current;
    if (!zone || !btn) return;
    const rect = zone.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;
    const dx = (e.clientX - cx) * 0.35;
    const dy = (e.clientY - cy) * 0.35;
    btn.style.transform = `translate(${dx}px, ${dy}px)`;
  };

  const handleMagnetLeave = () => {
    if (magnetBtnRef.current) magnetBtnRef.current.style.transform = '';
  };

  const navClass = ['navbar', scrolled ? 'navbar--scrolled' : '']
    .filter(Boolean).join(' ');

  return (
    <nav className={navClass}>
      <a href="#home" className="brand">
        <img
          src={require('../images/MKMonogramWhite.svg').default}
          alt="logo"
          className="logo"
        />
        <div className="logo-info">
          <div className="logo-text">Mac &amp; Kyla</div>
          <div className="logo-description">Our Wedding</div>
        </div>
      </a>

      <div className="nav-right">
        <div
          className="nav-btn hire-btn-magnet"
          ref={magnetZoneRef}
          onMouseMove={handleMagnet}
          onMouseLeave={handleMagnetLeave}
        >
          <div ref={magnetBtnRef}>
            <a href="#details" className="hire-btn">
              Details
            </a>
          </div>
        </div>
        <button
          className={`menu-btn${burgerAnim ? ` menu-btn--${burgerAnim}` : ''}`}
          onClick={onMenuToggle}
          aria-label="Open menu"
        >
          <div className="menu-icon">
            <div className="menu-icon-line menu-icon-line--top" />
            <div className="menu-icon-line menu-icon-line--bottom" />
          </div>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
